export default function getResource(label, vars = []) {
    const resources = {
        newText: 'NOUVEAUTÉ',
        rougeBadge: 'EXCLUSIVITÉ ROUGE'
    };
    return resources[label];
}
